import { SVGProps, Ref, forwardRef } from 'react';

export const VideocameraOutlinedSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m23.207 18.263 6.393 3.165V10.572l-6.393 3.165-.44-3.323c-.314-2.372-1.03-3.481-1.954-4.126-1.057-.737-2.876-1.221-6.146-1.221h-4c-3.867 0-5.682.675-6.637 1.63S2.4 9.467 2.4 13.333v5.334c0 3.867.675 5.681 1.63 6.636s2.77 1.63 6.637 1.63h4c3.27 0 5.089-.484 6.146-1.221.925-.645 1.64-1.754 1.954-4.126zM32 8v16h-2.613l-4.24-2.1a12.6 12.6 0 0 1-.54 2.412c-1.25 3.669-4.243 5.021-9.94 5.021h-4C2.667 29.333 0 26.667 0 18.667v-5.334c0-8 2.667-10.666 10.667-10.666h4c5.697 0 8.69 1.352 9.94 5.021.244.714.42 1.515.54 2.411L29.386 8z"
                fill="currentColor"
            />
        </g>
    </svg>
));
VideocameraOutlinedSize32Glyph.displayName = 'VideocameraOutlinedSize32Glyph';
